import { render, staticRenderFns } from "./Kolonne.vue?vue&type=template&id=de501244"
import script from "./Kolonne.vue?vue&type=script&lang=js"
export * from "./Kolonne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports